import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { AttachmentsCellProps } from '../../../../../core/types/coreTypes';
import { useAppDispatch } from '../../../../../store/hooks';
import { PermissionEnum } from '../../../../../core/enums/dictionariesEnums';
import ConfirmationModal from '../../../../../core/components/confirmation-modal/ConfirmationModal';
import AttachmentsRow from '../../../../../common/components/attachments-table/AttachmentsRow';
import usePermission from '../../../../../permissions-handling/permissionHook';
import { deleteVehicleAttachmentThunk, getVehicleAttachmentByIdThunk } from '../../../../../store/thunks/vehicles/vehicleAttachmentsThunks';

const VehicleAttachmentsCell: React.FC<AttachmentsCellProps> = ({
  attach,
  openEditModal,
  checked,
  checkRow,
}) => {
  const { id } = useParams();

  const dispatch = useAppDispatch();
  const [isModal, setModal] = useState(false);
  const allowedManage = usePermission(PermissionEnum.VehicleEditFields);
  const actions = [
    {
      label: 'Edit comment',
      icon: <FontAwesomeIcon icon={faEdit} />,
      key: 'editComment',
      onClick: () => openEditModal(),
    },
    {
      label: 'Delete file',
      key: 'deleteFile',
      icon: <FontAwesomeIcon icon={faTrashAlt} />,
      onClick: () => setModal(true),
    },
  ];
  return (
    <>
      <ConfirmationModal
        isVisible={isModal}
        onCancel={() => setModal(false)}
        confirmHandler={() => id && dispatch(deleteVehicleAttachmentThunk({
          vehicleId: +id,
          id: attach.id,
          closeModal: () => setModal(false),
        }))}
      />
      <AttachmentsRow
        allowedManage={!!allowedManage}
        attachment={attach}
        checked={checked}
        checkRows={checkRow}
        onClick={(attachId) => id && dispatch(getVehicleAttachmentByIdThunk({
          vehicleId: +id,
          id: attachId,
        }))}
        actions={actions}
      />
    </>
  );
};

export default VehicleAttachmentsCell;
